import { React, Component, Container, _ } from 'utils';
import { GiveawayStore, AuthStore, Creators } from 'model';
import { AuthForm } from './activities/chat';
import { Loading } from 'components';
import './prizeform.less';

class PrizeForm extends Component {

	static getStores() {
		return [ GiveawayStore, AuthStore ];
	}

	static calculateState() {
		return {
			prize: GiveawayStore.getPrize(),
			loading: GiveawayStore.isLoading(),
			error: GiveawayStore.isError(),
			thankYou: GiveawayStore.isThankYou(),
			msg: AuthStore.getMessage(),
			auth: AuthStore.isAuthorized() == false,
			standId: GiveawayStore.getStandId()
		}
	}

	handleSubmit = (event) => {
		event.preventDefault();
		var { prize, standId } = this.state;

		Creators.applyForGiveaway({
			giveaway: prize.id,
			email: $(this.email).val(),
			phone: $(this.phone).val(),
			content: $(this.note).val(),
			stand: standId
		});
	}

	componentDidMount() {
		$(window).on('vv.overlay', this.handleReset);
	}

	componentWillUnmount() {
		$(window).off('vv.overlay', this.handleReset);
	}

	handleReset = (event, args) => {
		if(args.name == 'nagrada' && args.visible == true) {
			$(this.note).val('');
		}
	}

	render() {

		var { loading, error, thankYou, auth, msg } = this.state;

		var css = [];

		if(loading) {
			css.push('loading');
		}

		if(error) {
			css.push('error');
		}

		if(thankYou) {
			css.push('thank-you');
		}

		if(auth) {
			return <div className="content prize-form">
				<AuthForm msg={ msg } />
			</div>;
		} else {
			return <div className="content prize-form">
				<div className="card">
					<h1 className="display-4">{_('Prize')}</h1>
					<p>{_('prize.form.intro')}</p>
					<form className={ css.join(' ') } onSubmit={ this.handleSubmit }>
						<div className="form-group">
							<label>{_('Email')}</label>
							<input type="email" className="form-control" ref={ input => this.email = input } required></input>
						</div>
						<div className="form-group">
							<label>{_('Phone number')}</label>
							<input className="form-control" type="text" ref={ input => this.phone = input }></input>
						</div>

						<div className="form-group">
							<label>{_('prize.form.question')}</label>
							<textarea className="form-control"  rows="3" ref={ input => this.note = input } required></textarea>
						</div>
						<p className="text-center">
							<button type="submit" className="btn btn-lg btn-primary">{_('Send')}</button>
						</p>
						<div className="shade loading">
							<Loading visible={true} description={_('Sending')} />
						</div>
						<div className="shade thank-you">
							<div>
								<i className="fa fa-check-circle fa-4x"></i>
								<div>{_('Thank you for your participation')}</div>
							</div>
						</div>
					</form>
				</div>
			</div>;
		}
	}
}

export default Container.create(PrizeForm);




// WEBPACK FOOTER //
// ./src/modules/components/prizeform.js